<mat-card>
  <mat-card-title>Commentaire</mat-card-title>
  <mat-card-content>
    <div class="com-container" fxLayout="row wrap">
      <span [innerHtml]="data?.text | newline | safeHtml"></span>
    </div>
  </mat-card-content>
</mat-card>
